import React from 'react'

export type SpecRow = {
  label: string
  value: string
}

interface SpecListProps {
  specs: SpecRow[]
}

export const SpecList: React.FC<SpecListProps> = ({ specs }) => {
  if (!specs || specs.length === 0) return null

  return (
    <dl className="mt-5 w-full border-t border-civo-cloud">
      {specs.map((row, i) => (
        <div
          key={i}
          className="flex items-center justify-between py-2.5 border-b border-civo-cloud body-copy-small"
        >
          <dt className="text-black/60 font-normal whitespace-nowrap">{row.label}</dt>
          <dd className="text-black font-medium text-right ml-4">{row.value}</dd>
        </div>
      ))}
    </dl>
  )
}
